
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kol",
      function () {
        return require("private-next-pages/kol/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kol"])
      });
    }
  